import { useQuery } from "@tanstack/react-query";

import CustomTableService from "services/CustomTable";

// Custom tables whose relationship columns point at this record —
// RBAC-filtered server-side and limited to tables with linked rows.
// Returns [] until loaded.
export function useLinkedTables(targetType, recordId) {
  const { data } = useQuery({
    queryKey: [targetType, recordId, "linkedTables"],
    queryFn: () => CustomTableService.getLinkedTables(targetType, recordId),
    enabled: !!recordId,
  });
  return data?.tables ?? [];
}
